import { parse } from 'qs';
export const getParamsFromURL = (url) => {
  return url;
};

export const getParamsFromNormalURL = (url) => {
  let params;
  if (url) {
    const urlArr = url.split('?');
    if (urlArr.length == 2) {
      params = parse(urlArr[1]);
    }
  }
  return params;
};
